<header class="flex justify-content-between light-bg">
  <div class="h-full flex align-items-center mx-3">
    <div class="rmsLogoImg">
      <img
        src="../../../assets/images/RMSlogo.png"
        width="100%"
        height="100%"
      />
    </div>

    <div class="border-left-1 border-clr flex ml-3">
      @if (!(UserData?.rolename === POSRoles.pos_kitchen_manager ||
      UserData?.rolename === POSRoles.pos_kitchen || UserData!.rolename ===
      POSRoles.pos_dispatcher) && UserData?.rolename !== 'POS Call Center') {
      <div
        routerLink="/"
        routerLinkActive="bg-primary"
        [routerLinkActiveOptions]="{ exact: true }"
        class="flex align-items-center py-2 px-3 ml-3 mr-2 cursor-pointer radius-8 border-clr border-1 header-links"
      >
        <div class="flex align-center justify-content-center">
          <i class="pi pi-home text-lg font-medium line-height-3"></i>
        </div>
        <div class="ml-2 fs-14 fw-600">Home</div>
      </div>

      }

      <!-- Call Center Dashboard -->
      @if (UserData?.rolename === 'POS Call Center') {
      <div
        routerLink="/call-center"
        routerLinkActive="bg-primary"
        [routerLinkActiveOptions]="{ exact: true }"
        class="flex align-items-center py-2 px-3 mx-2 cursor-pointer radius-8 border-clr border-1 header-links"
      >
        <div class="flex align-center justify-content-center">
          <i class="pi pi-th-large text-lg font-medium line-height-3"></i>
        </div>
        <div class="ml-2 fs-14 fw-600">Home</div>
      </div>
      }

      <!-- Todays Order -->
      @if (userPermision?.order_list?.can_access === 1 || userPermision == null
      && UserData?.rolename !== "POS Kitchen Manager" ? true :false ) {
      <div
        *ngIf="isShiftOpened || UserData?.rolename === 'POS Manager'"
        routerLink="/today-orders"
        routerLinkActive="bg-primary"
        class="flex align-items-center py-2 px-3 mx-2 cursor-pointer radius-8 border-clr border-1 header-links"
      >
        <div class="flex align-center justify-content-center">
          <svg
            width="18"
            height="18"
            viewBox="0 0 16 16"
            stroke-width="0"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.2757 11.7668C15.2757 11.7668 15.2757 11.7085 15.2757 11.6752V4.32516C15.2754 4.22953 15.2526 4.13531 15.209 4.05016C15.1477 3.91782 15.0414 3.81153 14.909 3.75016L8.24238 0.766825C8.16124 0.729993 8.07316 0.710938 7.98405 0.710938C7.89494 0.710938 7.80686 0.729993 7.72572 0.766825L1.05905 3.75016C0.951829 3.80412 0.861165 3.88602 0.796629 3.98723C0.732092 4.08843 0.696076 4.20518 0.692383 4.32516V11.6752C0.698613 11.7945 0.735664 11.9102 0.799925 12.011C0.864185 12.1118 0.953462 12.1942 1.05905 12.2502L7.72572 15.2335C7.8064 15.272 7.89466 15.292 7.98405 15.292C8.07344 15.292 8.1617 15.272 8.24238 15.2335L14.909 12.2502C15.0053 12.2061 15.0891 12.1389 15.1531 12.0546C15.2171 11.9702 15.2592 11.8714 15.2757 11.7668ZM1.94238 5.28349L7.35905 7.71683V13.7002L1.94238 11.2752V5.28349ZM8.60905 7.71683L14.0257 5.28349V11.2752L8.60905 13.7002V7.71683ZM8.00072 2.01683L13.1424 4.32516L8.00072 6.62516L2.85905 4.32516L8.00072 2.01683Z"
            />
          </svg>
        </div>
        <div class="ml-2 fs-14 fw-600">Today orders</div>
      </div>
      }

      <!-- Call Center Rider Dashboard -->
      @if (UserData?.rolename === 'POS Call Center') {
      <div
        routerLink="/call-center/rider-dashboard"
        routerLinkActive="bg-primary"
        [routerLinkActiveOptions]="{ exact: true }"
        class="flex align-items-center py-2 px-3 mx-2 cursor-pointer radius-8 border-clr border-1 header-links"
      >
        <div class="flex align-center justify-content-center font-medium line-height-3 text-xl">
          <svg
            stroke="currentColor"
            fill="currentColor"
            stroke-width="0"
            viewBox="0 0 24 24"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5z"></path>
            <path d="M16.5 6c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5v9c0 .83.67 1.5 1.5 1.5h3c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-3c-.83 0-1.5.67-1.5 1.5z"></path>
          </svg>
        </div>
        <div class="ml-2 fs-14 fw-600">Riders</div>
      </div>
      }
      <!-- Kitchen status -->
      @if (!(UserData?.rolename === POSRoles.pos_kitchen || UserData?.rolename
      === POSRoles.pos_dispatcher) && UserData?.rolename !== 'POS Call Center') { @if
      (userPermision?.kitchen_status?.can_access === 1 || userPermision == null
      ? true : false ) {
      <div
        *ngIf="isShiftOpened"
        routerLink="/kitchen-status"
        routerLinkActive="bg-primary"
        class="flex align-items-center px-3 mx-2 cursor-pointer radius-8 border-clr border-1 header-links"
        (click)="resetState()"
        [ngClass]="UserData!.user_role_id === 9 ? 'cpforTabs' : ''"
      >
        <div
          class="flex align-center justify-content-center font-medium line-height-3 text-xl"
        >
          <svg
            stroke="currentColor"
            fill="currentColor"
            stroke-width="0"
            viewBox="0 0 256 256"
            height="1em"
            width="1em"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M240,112a56.06,56.06,0,0,0-56-56c-1.77,0-3.54.1-5.29.26a56,56,0,0,0-101.42,0C75.54,56.1,73.77,56,72,56A56,56,0,0,0,48,162.59V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V162.59A56.09,56.09,0,0,0,240,112Zm-48,96H64V167.42a55.49,55.49,0,0,0,8,.58H184a55.49,55.49,0,0,0,8-.58Zm-8-56H170.25l5.51-22.06a8,8,0,0,0-15.52-3.88L153.75,152H136V128a8,8,0,0,0-16,0v24H102.25l-6.49-25.94a8,8,0,1,0-15.52,3.88L85.75,152H72a40,40,0,0,1,0-80l.58,0A55.21,55.21,0,0,0,72,80a8,8,0,0,0,16,0,40,40,0,0,1,80,0,8,8,0,0,0,16,0,55.21,55.21,0,0,0-.58-8l.58,0a40,40,0,0,1,0,80Z"
            ></path>
          </svg>
        </div>
        <div class="ml-2 fs-14 fw-600">Kitchen Status</div>
      </div>
      } }
      <!-- POS Kitchen -->
      @if (UserData?.rolename === POSRoles.pos_kitchen) {
      <div class="flex">
        <!-- <div class="flex align-items-center justify-content-center px-3 cpforTabs mx-2 cursor-pointer radius-8 border-clr border-1"
          routerLink="/separate-kitchen"
          (click)="OrderStatusTabs(0)"
          [ngClass]="seletedTab === 0 ? 'bg-primary' : ''"
        >
          <div class="ml-2 fs-14 fw-600 flex">
            All
            <div
              class="ml-2 border-circle danger-btn text-white w-1rem h-1rem textxs flex justify-content-center align-items-center text-center"
            >
              <span class="fs-10">
                {{ allKitchenOrder.length }}
              </span>
            </div>
          </div>
        </div> -->

        <!-- <div class="flex align-items-center justify-content-center px-3 cpforTabs mx-2 cursor-pointer radius-8 border-clr border-1"
          routerLink="/separate-kitchen"
          (click)="OrderStatusTabs(2)"
          [ngClass]="seletedTab === 2 ? 'bg-primary' : ''">
          <div class="ml-2 fs-14 fw-600 flex">
            Received
            <div
              class="ml-2 border-circle danger-btn text-white w-1rem h-1rem order_counters text-xs flex justify-content-center align-items-center text-center"
            >
              <span class="fs-10">
                {{ recievedOrder.length }}
              </span>
            </div>
          </div>
        </div> -->

        <div
          class="flex align-items-center justify-content-center px-3 cpforTabs mx-2 cursor-pointer radius-8 border-clr border-1"
          routerLink="/separate-kitchen"
          (click)="OrderStatusTabs(3)"
          [ngClass]="seletedTab === 3 ? 'bg-primary' : ''"
        >
          <div class="ml-2 fs-14 fw-600 flex">
            Preparing
            <div
              class="ml-2 border-circle danger-btn text-white w-1rem h-1rem order_counters text-xs flex justify-content-center align-items-center text-center"
            >
              <span class="fs-10">
                {{ preparingOrder.length + recievedOrder.length }}
              </span>
            </div>
          </div>
        </div>
      </div>
      }
      <!-- POS Kitchen -->
      @if (UserData?.rolename === POSRoles.pos_dispatcher) {
      <div class="flex">
        <div
          class="flex align-items-center justify-content-center px-3 cpforTabs mx-2 cursor-pointer radius-8 border-clr border-1"
          routerLink="/separate-kitchen"
          (click)="OrderStatusTabs(4)"
          [ngClass]="seletedTab === 4 ? 'bg-primary' : ''"
        >
          <div class="ml-2 fs-14 fw-600 flex">
            Ready
            <div
              class="ml-2 border-circle danger-btn text-white w-1rem h-1rem order_counters text-xs flex justify-content-center align-items-center text-center"
            >
              <span class="fs-10">
                {{ readyOrder.length }}
              </span>
            </div>
          </div>
        </div>
      </div>
      }
      @if(!(UserData!.rolename === POSRoles.pos_kitchen_manager ||
      UserData!.rolename === POSRoles.pos_kitchen || UserData!.rolename ===
      POSRoles.pos_dispatcher) && UserData!.rolename !== 'POS Call Center') {
      <div
        [ngClass]="UserData.user_role_id === 10 ? 'cpAtKitchenScreen' : 'py-2'"
        class="flex align-items-center px-3 mx-2 cursor-pointer radius-8 border-clr border-1"
        id="toggle"
      >
        <div class="mr-2 fs-14 fw-600" id="toggle">More</div>
        <div
          class="flex align-center justify-content-center font-medium line-height-3 text-lg text-2xl mt-1"
          id="toggle"
        >
          <i class="pi pi-angle-down" id="toggle"></i>
        </div>
      </div>
      }
    </div>
    <!-- <div class="flex" *ngIf="userDetail!==null">
      <strong>
        {{ userDetail?.name }}
      </strong> | 
       <strong>
        {{ userDetail?.cell_num }}
      </strong>
    </div> -->
  </div>

  <!-- <div
    *ngIf="localStorageData.user?.rolename === 'POS Call Center'"
    (click)="openBranchSelectDialoge()"
    class="branch_selector"
  >
    {{ localStorageData.selected_branche?.name ?? "Select branch" }}
  </div> -->

  <div class="h-full flex align-items-center mx-3">
    <!-- Dail-input Field -->
    @if (!(UserData!.rolename === POSRoles.pos_kitchen_manager||
    UserData!.rolename === POSRoles.pos_kitchen || UserData!.rolename ===
    POSRoles.pos_dispatcher)) {

    <div
      *ngIf="
        isShiftOpened === true &&
        UserData?.rolename !== 'POS Call Center' &&
        UserData?.rolename !== 'POS Manager' &&
        UserData?.rolename !== 'POS Kitchen Manager' &&
        !UserData.is_shift_auto
      "
    >
      <p-button
        routerLink="/close-shift"
        styleClass="border-round-lg danger-bg	"
      >
        Close Shift
      </p-button>
    </div>
    <div
      *ngIf="
        isShiftOpened === false &&
        UserData?.rolename !== 'POS Manager' &&
        UserData?.rolename !== 'POS Kitchen Manager'
      "
    >
      <p-button
        (onClick)="showOpenShiftDialogue = true; openCounterForm.reset()"
        styleClass="border-round-lg success-bg"
      >
        Open Shift
      </p-button>
    </div>
      <div
        class="white-bg border-1 border-clr radius-8 pl-3 cpx-6 cpr-4 mr-3 flex"
      >
      <div class="mr-1 mt-2 cursor-pointer">
        <img src="assets/Svgs/dailIcon.svg" alt="" />
      </div>
      <div class="">
        <form
          action="
        "
          >
            <input
              type="text"
              #searchInput
              placeholder=" Search Number"
              value="{{this.userDetail?.cell_num}}"
              id="inp"
              class="fs-14"
              (keyup.enter)="searachRecordbyPhone()"
              [disabled]="this.userDetail?.cell_num"
              minlength="11"
              maxlength="11"
            />
          </form>
        </div>

      <!-- <span class="p-2 radius-6 light-text success-bg cursor-pointer">
        <i class="pi pi-phone"></i>
      </span> -->
      <span
        (click)="searachRecordbyPhone()"
        *ngIf="!this.userDetail?.cell_num"
        class="p-2 radius-6 border-1 border-clr dark-text cursor-pointer"
      >
        <i *ngIf="!callCenterLoader" class="pi pi-search"></i>
        <i *ngIf="callCenterLoader" class="pi pi-spin pi-spinner"></i>
      </span>
      <span
        *ngIf="this.userDetail?.cell_num"
        (click)="clearInput()"
        class="p-2 radius-6 border-1 border-clr dark-text cursor-pointer"
      >
        <i class="pi pi-times"></i>
      </span>
    </div>

    } @if (UserData!.rolename === POSRoles.pos_kitchen || UserData!.rolename ===
    POSRoles.pos_dispatcher) {
    <span
      class="border-1 border-round-lg cursor-pointer border-clr m-3"
      pTooltip="Refresh Order"
      tooltipPosition="bottom"
      (click)="reloadPOSKitchenAPI()"
    >
      <i class="pi pi-sync cp-8"></i>
    </span>
    }
    <!-- Profile-Icon -->
    <div
      class="mr-3"
      [pTooltip]="UserData.name"
      tooltipPosition="bottom"
      (click)="op.toggle($event)"
    >
      <img
        [src]="UserData.restaurant_branch_logo_url"
        class="profileImg"
        onerror="this.src = 'assets/images/profile.jpg' "
        alt="logo"
      />
    </div>
    <!-- Notification -->
    @if (!(UserData!.user_role_id === 9 || UserData!.user_role_id === 10 ||
    UserData!.rolename === POSRoles.pos_dispatcher || UserData!.rolename ===
    'POS Call Center')) {
    <div>
      <div
        class="badge flex align-items-center justify-content-center border-circle text-white danger-bg fw-400 fs-8"
      >
        {{ pendingOrder.length }}
      </div>
      <span
        pTooltip="Notification"
        tooltipPosition="left"
        class="border-round-lg border-clr cp-8 border-1 cursor-pointer flex justify-content-center"
        (click)="toggleSidebar()"
      >
        <i class="pi pi-bell"></i>
      </span>
    </div>
    }
  </div>
</header>

<div
  class="light-bg radius-12"
  [ngClass]="
    (!(
      userPermision?.kitchen_status?.can_access === 1 &&
      userPermision?.order_list?.can_access === 1
    ) &&
      userPermision?.order_list?.can_access === 0) ||
    userPermision?.kitchen_status?.can_access === 0
      ? 'dropwdown-list-2'
      : 'dropwdown-list'
  "
  *ngIf="toggleDropdown"
>
  @if (true) {
  <!-- Order-history  -->
  @if (userPermision?.order_history?.can_access === 1 || userPermision == null ?
  true : false ) {
  <div
    routerLink="/order-history"
    routerLinkActive="bg-primary"
    class="flex align-items-center py-2 pr-3 cpl-12 mx-2 cursor-pointer radius-8 cmt header-links"
  >
    <div class="flex align-center justify-content-center">
      <i class="pi pi-history text-md font-medium line-height-3"></i>
    </div>
    <div class="ml-2 fs-14 fw-600">Order history</div>
  </div>
  }

  <!-- Rider -->
  @if(userPermision?.rider_allow?.can_access === 1 || userPermision == null ?
  true : false) {
  <div
    routerLink="/rider"
    routerLinkActive="bg-primary"
    class="flex align-items-center py-2 pr-3 cpl-12 mx-2 cursor-pointer radius-8 mt-1 header-links"
  >
    <div
      class="flex align-center justify-content-center font-medium line-height-3 text-lg text-2xl"
    >
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 24 24"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path fill="none" d="M0 0h24v24H0z"></path>
        <path
          d="M19 7c0-1.1-.9-2-2-2h-3v2h3v2.65L13.52 14H10V9H6c-2.21 0-4 1.79-4 4v3h2c0 1.66 1.34 3 3 3s3-1.34 3-3h4.48L19 10.35V7zM4 14v-1c0-1.1.9-2 2-2h2v3H4zm3 3c-.55 0-1-.45-1-1h2c0 .55-.45 1-1 1z"
        ></path>
        <path
          d="M5 6h5v2H5zM19 13c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
        ></path>
      </svg>
    </div>
    <div class="ml-2 fs-14 fw-600">Rider</div>
  </div>
  }
  <!-- Status -->
  @if(userPermision?.report_allow?.can_access === 1 || userPermision == null ?
  true : false) {
  <div  
    routerLink="/stats"
    routerLinkActive="bg-primary"
    class="flex align-items-center py-2 px-3 mx-2 cursor-pointer radius-8 mt-1 header-links"
  >
    <div class="flex align-center justify-content-center">
      <i class="pi pi-chart-bar text-md font-medium line-height-3"></i>
    </div>
    <div class="ml-2 fs-14 fw-600">Stats</div>
  </div>
  } @if(userPermision?.expense_allow?.can_access === 1 || userPermision == null
  ? true : false) {

  <div
    *ngIf="isShiftOpened"
    routerLink="/expense"
    routerLinkActive="bg-primary"
    class="flex align-items-center py-2 px-3 mx-2 cursor-pointer radius-8 mt-1 header-links"
  >
    <div class="flex align-center justify-content-center">
      <i class="pi pi-dollar text-md font-medium line-height-3"></i>
    </div>
    <div class="ml-2 fs-14 fw-600">Expense</div>
  </div>
  }
  <div
    *ngIf="UserData?.rolename === POSRoles.pos_manager"
    routerLink="/shift-reports"
    routerLinkActive="bg-primary"
    class="flex align-items-center py-2 px-3 mx-2 cursor-pointer radius-8 mt-1 header-links"
  >
    <div class="flex align-center justify-content-center">
      <i class="pi pi-file text-md font-medium line-height-3"></i>
    </div>
    <div class="ml-2 fs-14 fw-600">Shift Report</div>
  </div>

  }
</div>

@if (visibleNotiBar && UserData?.rolename !== 'POS Kitchen Manager' &&
UserData?.rolename !== 'POS Kitchen' && UserData?.rolename !== 'POS Dispatcher'
&& UserData?.rolename !== 'POS Manager' ) {
<app-pending-orders
  [pendingOrderList]="pendingOrder"
  [loader]="loading"
  (closePanelEvent)="this.visibleNotiBar = $event; stopAudio()"
  (stopAudio)="stopAudio()"
></app-pending-orders>
}

<span class="hidden">
  <audio controls loop #audioSource>
    <source [src]="audioUrl" type="audio/wav" />
    <source [src]="audioUrl" type="audio/wav" />
    Your browser does not support the audio element.
  </audio>
</span>

<p-overlayPanel #op [style]="{ width: '200px' }" [showCloseIcon]="false">
  <ng-template pTemplate="content">
    <div class="">
      <div
        class="flex justify-content-center align-items-center flex-column p-2"
      >
        <div class="fs-15 fw-600">{{ UserData?.rolename }}</div>
        <div class="fs-14">
          {{ UserData.name }}({{ UserData.restaurant_name }})
        </div>
      </div>
      <div class="border-1 border-clr"></div>

      @if (UserData.user_role_id === 8 || UserData.user_role_id === 9 ||
      UserData.user_role_id === 7 ) {
      <div
        class="flex align-items-center p-2 cursor-pointer header-links"
        routerLink="/layout-settings"
        (click)="op.toggle($event)"
      >
        <i class="pi pi-cog text-md font-medium line-height-3"></i>
        <span class="ml-2 fs-14 fw-600">Layout Settings</span>
      </div>
      <div class="border-1 border-clr"></div>
      }

      <div
        class="flex align-items-center p-2 cursor-pointer header-links"
        (click)="handleLogout()"
      >
        <i class="pi pi-sign-out text-md font-medium line-height-3"></i>
        <span class="ml-2 fs-14 fw-600">Logout</span>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>

<!-- open shift dialoge -->
<p-dialog
  [(visible)]="showOpenShiftDialogue"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="true"
  [style]="{ width: '60vw' }"
  [draggable]="false"
>
  <form [formGroup]="openCounterForm">
    <div>
      <p class="flex justify-content-center text-2xl fw-600">Opening Counter</p>
      <div class="grid">
        <div class="col-6">
          <input
            class="w-full"
            type="text"
            pInputText
            formControlName="opening_amount"
            placeholder="opening amount"
          />
          @if (openCounterForm.touched &&
          openCounterForm.get('opening_amount')?.hasError('required')) {
          <small class="danger-text"> Opening amount is required</small>
          } @if (openCounterForm.get('opening_amount')?.touched &&
          openCounterForm.get('opening_amount')?.hasError('pattern')) {
          <small class="danger-text"> Amount should be numeric </small>
          } @if (openCounterForm.get('opening_amount')?.touched &&
          openCounterForm.get('opening_amount')?.hasError('maxlength')) {
          <small class="danger-text"> Amount max length 6 digit. </small>
          }
        </div>

        <div class="col-6">
          <textarea
            class="w-full"
            rows="1"
            cols="20"
            formControlName="opening_remarks"
            placeholder="opening remarks"
            pInputTextarea
          ></textarea>
        </div>
      </div>
    </div>

    <!-- closing counter...... -->

    <div class="mt-4 text-right">
      <p-button styleClass="border-round-lg success-bg" (click)="openShift()">
        <div class="flex justify-content-center align-items-center text-center">
          <i
            *ngIf="openingShift"
            class="pi pi-spin pi-spinner px-2"
            style="font-size: 1rem"
          ></i>
        </div>
        <span *ngIf="!openingShift"> Open Shift </span>
      </p-button>
    </div>
  </form>
</p-dialog>



 <!-- pipelin testing -->

<app-call-center-add-user
  [localStorageData]="localStorageData"
  [showCustomerDialogExt]="showCustomerDialogExt"
  (closeEmitter)="showCustomerDialogExt = { show: false, customer: false, address: false, isEdit: false, editAddressId: 0 }"
></app-call-center-add-user>
